export const CONTACT = {
  phone: "07874 849470",
  phoneRaw: "07874849470",
  whatsapp: "447874849470",
  email: "bea@mjlmaintenance.co.uk",
  area: "Buckinghamshire & surrounding areas",
  instagram: "https://www.instagram.com/mjl_maintenance_and_locks",
  facebook: "https://www.facebook.com/profile.php?id=100055947836479",
};

export const SERVICES = [
  {
    key: "locksmith",
    title: "Locksmith Services",
    image:
      "https://images.unsplash.com/flagged/photo-1564767609213-c75ee685263a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBsb2Nrc21pdGglMjBmaXhpbmclMjBkb29yfGVufDB8fHx8MTc4MTc4MzUwMXww&ixlib=rb-4.1.0&q=85",
    icon: "KeyRound",
    items: [
      "Lock repairs",
      "Lock replacements",
      "Lock upgrades",
      "UPVC door lock repairs",
      "Emergency lockouts",
      "Security assessments",
      "Key cutting solutions",
    ],
  },
  {
    key: "maintenance",
    title: "Property Maintenance",
    image:
      "https://images.unsplash.com/photo-1731168273756-e02cae42265b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBsb2Nrc21pdGglMjBmaXhpbmclMjBkb29yfGVufDB8fHx8MTc4MTc4MzUwMXww&ixlib=rb-4.1.0&q=85",
    icon: "Wrench",
    items: [
      "General repairs",
      "Home improvements",
      "Property maintenance",
      "Door installations",
      "Window repairs",
      "Handyman services",
    ],
  },
  {
    key: "joinery",
    title: "Bespoke Home Offices & Joinery",
    image: "/mjl-office.jpg",
    icon: "Hammer",
    items: [
      "Custom office installations",
      "Fitted furniture",
      "Storage solutions",
      "Workspace design",
      "Bespoke cabinetry",
    ],
  },
  {
    key: "security",
    title: "Security Upgrades",
    image:
      "https://images.pexels.com/photos/279810/pexels-photo-279810.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "ShieldCheck",
    items: [
      "Additional locks",
      "Van security locks",
      "Home security improvements",
      "Commercial security solutions",
    ],
  },
  {
    key: "clearance",
    title: "Rubbish Clearance Services",
    image: "/mjl-van.jpg",
    icon: "Truck",
    items: [
      "House clearances",
      "Garden waste removal",
      "Garage clearances",
      "Shed clearances",
      "Office waste removal",
      "Commercial waste disposal",
      "Licensed waste carrier",
    ],
  },
];

export const TRUST = [
  "Local trusted business",
  "Fast response times",
  "Fully insured",
  "Free quotations",
  "Residential & commercial work",
  "High-quality workmanship",
  "Competitive pricing",
];

export const PROJECTS = [
  {
    title: "Front Door Supply & Installation",
    before:
      "https://images.unsplash.com/photo-1558036117-15d82a90b9b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    after:
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    description:
      "Removed a worn, draughty front door and supplied & fitted a new secure composite door with multi-point locking.",
    outcome: "Improved kerb appeal, insulation and home security for the homeowner.",
  },
  {
    title: "Bespoke Home Office Installation",
    before:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    after:
      "https://images.pexels.com/photos/20771838/pexels-photo-20771838.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "Designed and built a fitted home office with bespoke cabinetry, desk and integrated storage solutions.",
    outcome: "A productive, clutter-free workspace tailored to the client's room.",
  },
  {
    title: "Van Security Lock Fitting",
    before:
      "https://images.unsplash.com/photo-1605152276897-4f618f831968?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    after:
      "https://images.unsplash.com/photo-1632823471565-1ecdf5e0aa6f?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    description:
      "Fitted heavy-duty deadlocks and slam locks to a tradesman's work van to protect tools and equipment.",
    outcome: "Peace of mind and reduced insurance risk against van break-ins.",
  },
  {
    title: "Lock Replacement Project",
    before:
      "https://images.unsplash.com/photo-1622372738946-62e02505feb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    after:
      "https://images.unsplash.com/flagged/photo-1564767609213-c75ee685263a?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    description:
      "Replaced a faulty UPVC door mechanism and upgraded to an anti-snap British Standard euro cylinder.",
    outcome: "Smooth operation and insurance-approved security for the property.",
  },
  {
    title: "House & Garden Clearance",
    before:
      "https://images.unsplash.com/photo-1610540881356-7b7d7d29b3a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    after:
      "https://images.unsplash.com/photo-1558904541-efa843a96f01?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    description:
      "Full house and garden clearance with all waste removed and responsibly disposed of by a licensed carrier.",
    outcome: "A clean, ready-to-let property handed back to the landlord.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sarah T.",
    location: "Aylesbury",
    text: "Excellent service, arrived quickly and completed the job to a very high standard.",
  },
  {
    name: "James M.",
    location: "High Wycombe",
    text: "Reliable, friendly and reasonably priced. Highly recommended.",
  },
  {
    name: "Linda P.",
    location: "Amersham",
    text: "Fantastic workmanship and great communication from start to finish.",
  },
  {
    name: "David R.",
    location: "Chesham",
    text: "Sorted our emergency lockout within the hour. Professional and honest pricing.",
  },
];

export const AREAS = [
  "Aylesbury",
  "High Wycombe",
  "Milton Keynes",
  "Amersham",
  "Chesham",
  "Beaconsfield",
  "Marlow",
  "Princes Risborough",
  "Wendover",
];

export const SERVICE_OPTIONS = [
  "Locksmith Services",
  "Property Maintenance",
  "Bespoke Home Office / Joinery",
  "Security Upgrades",
  "Rubbish Clearance",
  "Emergency Lockout",
  "Other",
];
